import { FC } from 'react'
import styles from './ResultBase.module.css'

interface ResultBaseProps {
  title?: string
  children: React.ReactNode
}

const ResultBase: FC<ResultBaseProps> = ({ title, children }) => {
  return (
    <>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.container}>{children}</div>
    </>
  )
}

export default ResultBase
